module.exports = __webpack_public_path__ + "5586653e25a9490f10455db74332de71.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/m31_bers_1824.jpg
// module id = 9
// module chunks = 0